export default __webpack_public_path__ + "static/media/top-banner.c5eba688.png";